import { BaseService } from "../../core/baseService";
import { GlobalSearchResultDto } from "../types/search.types";
import { ApiResult } from "../../core/types";

export interface SearchServiceInterface {
  search(query: string): Promise<ApiResult<GlobalSearchResultDto>>;
}

export class SearchService
  extends BaseService
  implements SearchServiceInterface
{
  async search(query: string): Promise<ApiResult<GlobalSearchResultDto>> {
    const params = this.buildQueryParams({ q: query });

    return this.handleRequest<GlobalSearchResultDto>(
      this.client.get("/api/admin/search", { params }),
    );
  }
}
